import React, { FC, memo, useEffect, useRef } from 'react';
import cn from 'classnames';

import { getEnvelopeCheckboxKey } from '@hooks/envelopes';
import { IEnvelopeProps as IProps } from '@views/envelopes/types';

import EnvelopeActions from './EnvelopeActions';
import EnvelopeCheckbox from './EnvelopeCheckbox';
import EnvelopeFieldsListCell from './EnvelopeFieldsListCell';
import EnvelopeIcons from './EnvelopeIcons';
import EnvelopLastChange from './EnvelopeLastChange';
import EnvelopeStatus from './EnvelopeStatus';
import EnvelopeSubject from './EnvelopeSubject';
import styles from './EnvelopeItem.module.scss';

interface IEnvelopeListItemProps extends IProps {
  knownFieldKeys: string[];
}

const EnvelopeListItem: FC<IEnvelopeListItemProps> = ({
  envelope,
  envelopeFields,
  availableLabels,
  knownFieldKeys,
  checkbox,
  selectedCheckbox,
  currentBoxOguid,
  idx,
}) => {
  const {
    oguid,
    direction,
    directions,
    allowedActions,
    subject,
    recipients,
    flowState,
    taskCompletedCount,
    taskTotalCount,
    lastActionDateTime,
    fields,
  } = envelope;

  const trRef = useRef<HTMLTableRowElement>(null);

  useEffect(() => {
    if (idx === 0) {
      trRef.current?.scrollIntoView({
        behavior: 'auto',
        block: 'end',
      });
    }
  }, [idx]);

  return (
    <tr className={cn(styles.listRow, !envelope.isRead && styles.unreadRow)} ref={trRef}>
      <EnvelopeCheckbox
        oguid={getEnvelopeCheckboxKey(envelope)}
        checkbox={checkbox}
        selectedCheckbox={selectedCheckbox}
      />
      <EnvelopeIcons
        directions={directions}
        allowedActions={allowedActions}
      />
      <EnvelopeSubject
        subject={subject}
        recipients={recipients}
        oguid={oguid}
        boxOguid={currentBoxOguid}
        direction={direction}
        labels={envelope.labels}
        availableLabels={availableLabels}
      />
      <EnvelopeFieldsListCell
        envelopeFields={envelopeFields}
        fields={fields}
        knownFieldKeys={knownFieldKeys}
      />
      <EnvelopeStatus
        flowState={flowState}
        taskCompletedCount={taskCompletedCount}
        taskTotalCount={taskTotalCount}
      />
      <EnvelopLastChange
        lastActionDateTime={lastActionDateTime}
      />
      <EnvelopeActions
        envelope={envelope}
        oguid={oguid}
        allowedActions={allowedActions}
        subject={subject}
        boxOguid={currentBoxOguid}
      />
    </tr>
  );
};

export default memo(EnvelopeListItem);
